export const filter = {
    id: null,
    kpTemplateId: null,
    date: '',
    end_date: '',
    comment: '',
    created_at: '',
    updated_at: '',        
};